import { useEffect } from "react";

export const PageTitle = ({ title }: { title: string }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title + " | " + prevTitle;
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
  return <></>;
};
